import Plan from "./plan"
import TogglePlans from "./toggle-plans"
import usePlanFilters from "./use-plan-filters"

const Subscriptions = ({
  plans,
  selectedPlanId,
  selectedPlan,
  isSubmitting,
  onSelect,
  onSubmit,
}) => {
  const { activeFilter, setActiveFilter } = usePlanFilters({ selectedPlan })

  const handleChange = (filter) => {
    setActiveFilter(filter)

    const selectedPlan = plans.find((plan) => plan.id === selectedPlanId)

    if (!selectedPlan) {
      return
    }

    const planMatch = plans.find(
      (plan) => plan.title === selectedPlan.title && plan.instalments === filter
    )

    onSelect(planMatch.id)
  }

  const filteredPlans = plans.filter(
    (plan) => plan.instalments === activeFilter
  )

  return (
    <div
      sx={{
        gridColumn: [null, "1 / -1"],
        p: 4,
        background: "white",
        borderRadius: "8px",
        border: ["none", "1px solid #E1E1E1"],
      }}
      data-component-name="PlanSelectionSubscriptionPlans"
    >
      <div
        sx={{
          fontFamily: "NeueHaasGroteskDisplay Pro",
          fontSize: 4,
          lineHeight: 1.4,
        }}
        data-testid="web-portal-plan-selection-subscription-plans-title"
      >
        Auto-Refill
      </div>

      <TogglePlans activeFilter={activeFilter} onClick={handleChange} />
      <div
        sx={{
          display: "grid",
          gridTemplateColumns: [null, "repeat(3, 1fr)"],
          gap: 4,
        }}
        data-testid="web-portal-plan-selection-anti-aging-subscription-plans"
      >
        {filteredPlans.map((plan) => (
          <Plan
            key={plan.id}
            plan={plan}
            selectedPlanId={selectedPlanId}
            isSubmitting={isSubmitting}
            onSelect={onSelect}
            onSubmit={onSubmit}
          />
        ))}
      </div>
    </div>
  )
}

export default Subscriptions
